document.addEventListener('alpine:init', () => {

  Alpine.data('tabNavigation', () => ({
    activeTab: null,

    init() {
      const firstTab = this.$root.querySelector('[role="tab"]');

      if (firstTab) {
        this.activeTab = firstTab.dataset.tabTarget;
      }
    },

    selectTab(tab) {
      this.activeTab = tab;
    }
  }));

});